<script setup>
import {useSystem} from "../../store/system";
import {useProducts} from "../../store/products";
import {onActivated, onMounted, ref, watch} from "vue";
import {useRoute, useRouter} from "vue-router";
import {useUser} from "../../store/user";
import {ElMessage} from "element-plus";

const route = useRoute()
const router = useRouter()
const systemStore = useSystem()

const productStore = useProducts()
onActivated(() => {
  productStore.productDetailApi(route.query.id)
})

const tempColors = []
const colorEqule = () => {
  if (tempColors.length % 2 === 0) {
    let color = systemStore.getRandomColor()
    tempColors.push("stats__dodger--" + color)
  }else{
    tempColors.push(tempColors[tempColors.length-1])
  }
  return tempColors[tempColors.length-1]
}

const productNum = ref(1)
const dialogVisible = ref(false)
const submitLoading = ref(false)

//购买产品
const submit = () => {
  if (!useUser().getToken || useUser().getToken.length <= 0){
    ElMessage({
      duration: 1500,
      message: "Please log in first!",
      type: 'error',
      onClose: () => {
        router.push({path: '/Signin'})
      }
    })
  }else{
    submitLoading.value = true
    productStore.buyProductApi(productStore.getProductDetail.products_id, productNum.value, (isSubmit) => {
      if (isSubmit) {
        submitLoading.value = false
        dialogVisible.value = false
      }
    })
  }

}

</script>

<template>
  <div>
    <!-- head -->
    <div class="section section--head">
      <div class="container">
        <div class="row">
          <!-- title -->
          <div class="col-12">
            <div class="section__title">
              <el-image class="tw-w-[7rem] tw-h-[7rem] tw-mb-3 tw-rounded-full" fit="cover" :src="productStore.getProductDetail.image? productStore.getProductDetail.image: 'img/logo.svg'"></el-image>
              <h1 class="tw-mt-2">{{productStore.getProductDetail.name}}</h1>
<!--              <p>More features with own Centure token.</p>-->
            </div>
          </div>
          <!-- end title -->
        </div>
      </div>
    </div>
    <!-- end head -->

    <!-- products -->
    <section class="section">
      <div class="container">

        <el-row :gutter="systemStore.getIsMobile? 0: 30" style="font-family: 'Manrope';">
          <el-col :span="24" :md="8" class="tw-mt-4">
            <div class="card-bg-active tw-mt-0 tw-h-full tw-relative tw-p-5 tw-text-center">
              <div class="tw-text-[1.2rem] tw-font-bold">Contract Duration</div>
              <div class="tw-text-[1.2rem] tw-font-bold tw-mt-2">{{parseFloat(productStore.getProductDetail.products_day)}} Day</div>

              <span class="screw screw--lines-bl"></span>
              <span class="screw screw--lines-br"></span>
              <span class="screw screw--lines-tr"></span>
              <span class="screw screw--lines-tl"></span>
            </div>
          </el-col>
<!--          <el-col :span="24" :md="8" class="tw-mt-4">-->
<!--            <div class="card-bg-active tw-mt-0 tw-h-full tw-relative tw-p-5 tw-text-center">-->
<!--              <div class="tw-text-[1.2rem] tw-font-bold">Contract Price</div>-->
<!--              <div class="tw-text-[1.2rem] tw-font-bold tw-mt-2">$ {{parseFloat(productStore.getProductDetail.amount)}}</div>-->

<!--              <span class="screw screw&#45;&#45;lines-bl"></span>-->
<!--              <span class="screw screw&#45;&#45;lines-br"></span>-->
<!--              <span class="screw screw&#45;&#45;lines-tr"></span>-->
<!--              <span class="screw screw&#45;&#45;lines-tl"></span>-->
<!--            </div>-->
<!--          </el-col>-->
          <el-col :span="24" :md="8" class="tw-mt-4" v-if="productStore.getProductDetail.profit_type == 1">
            <div class="card-bg-active tw-mt-0 tw-h-full tw-relative tw-p-5 tw-text-center">
              <div class="tw-text-[1.2rem] tw-font-bold">Daily Rewards</div>
              <div class="tw-text-[1.2rem] tw-font-bold mt-2">$ {{parseFloat(productStore.getProductDetail.fixed_profit)}}</div>

              <span class="screw screw--lines-bl"></span>
              <span class="screw screw--lines-br"></span>
              <span class="screw screw--lines-tr"></span>
              <span class="screw screw--lines-tl"></span>
            </div>
          </el-col>
          <el-col :span="24" :md="8" class="tw-mt-4" v-if="productStore.getProductDetail.profit_type == 2">
            <div class="card-bg-active tw-mt-0 tw-h-full tw-relative tw-p-5 tw-text-center">
              <div class="tw-text-[1.2rem] tw-font-bold">Daily Rewards</div>
              <div class="tw-text-[1.2rem] tw-font-bold mt-2">$ {{parseFloat(productStore.getProductDetail.amount) * parseFloat(productStore.getProductDetail.percent_profit)}}</div>

              <span class="screw screw--lines-bl"></span>
              <span class="screw screw--lines-br"></span>
              <span class="screw screw--lines-tr"></span>
              <span class="screw screw--lines-tl"></span>
            </div>
          </el-col>
          <el-col :span="24" :md="8" class="tw-mt-4">
            <div class="card-bg-active tw-mt-0 tw-h-full tw-relative tw-p-5 tw-text-center">
              <div class="tw-text-[1.2rem] tw-font-bold">Total Earnings</div>
              <div class="tw-text-[1.2rem] tw-font-bold mt-2">$ {{parseFloat(productStore.getProductDetail.expected_profit)}}</div>

              <span class="screw screw--lines-bl"></span>
              <span class="screw screw--lines-br"></span>
              <span class="screw screw--lines-tr"></span>
              <span class="screw screw--lines-tl"></span>
            </div>
          </el-col>
          <el-col :span="24" :md="8" class="tw-mt-4">
            <div class="card-bg-active tw-mt-0 tw-h-full tw-relative tw-p-5 tw-text-center">
              <div class="tw-text-[1.2rem] tw-font-bold">Principal Refund</div>
              <div class="tw-text-[1.2rem] tw-font-bold mt-2">
                <div class="tw-flex tw-justify-center tw-items-center" v-if="productStore.getProductDetail.return_capital == 1">
                  <i class="ti ti-circle-check tw-text-green-500 tw-mr-1 tw-text-[1.6rem]"></i>
                  Yes
                </div>
                <div v-else class="tw-flex tw-justify-center tw-items-center">
                  <i class="ti ti-exclamation-circle tw-text-red-500 tw-mr-1 tw-text-[1.6rem]"></i>
                  No
                </div>
              </div>

              <span class="screw screw--lines-bl"></span>
              <span class="screw screw--lines-br"></span>
              <span class="screw screw--lines-tr"></span>
              <span class="screw screw--lines-tl"></span>
            </div>
          </el-col>
          <el-col :span="24" :md="8" class="tw-mt-4">
            <div class="card-bg-active tw-mt-0 tw-h-full tw-relative tw-p-5 tw-text-center">
              <div class="tw-text-[1.2rem] tw-font-bold">Matured Amount</div>
              <div class="tw-text-[1.2rem] tw-font-bold mt-2">$ {{parseFloat(productStore.getProductDetail.amount)}} + $ {{parseFloat(productStore.getProductDetail.expected_profit)}}</div>

              <span class="screw screw--lines-bl"></span>
              <span class="screw screw--lines-br"></span>
              <span class="screw screw--lines-tr"></span>
              <span class="screw screw--lines-tl"></span>
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-row class="tw-mt-10">
              <el-col :span="systemStore.getIsMobile? 24: 12" class="tw-content-center" :class="systemStore.getIsMobile? 'tw-text-center': 'tw-text-right'">
                <el-input-number
                    :class="systemStore.getIsMobile? '': 'tw-mr-5'"
                    v-model="productNum"
                    :min="productStore.getProductDetail.min"
                    :max="productStore.getProductDetail.max"
                    size="large" />
              </el-col>
              <el-col :span="systemStore.getIsMobile? 24: 12">
                <button
                    class="section__btn"
                    :class="systemStore.getIsMobile? 'tw-justify-self-center tw-mt-5': 'tw-justify-self-left'"
                    type="button"
                    @click="dialogVisible = true">Invest Now</button>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="24" class="tw-mt-16" v-if="productStore.getProductDetail.buy_repeat == 0 && productStore.getProductDetail.products_id == 2">
            <div class="tw-flex tw-items-center">
              <div class="tw-p-5 tw-rounded-md tw-border-purple-500 tw-text-white tw-flex tw-items-center tw-text-[1rem] tw-border"><el-icon color="red" size="25" class="tw-mr-[5px]"><Warning /></el-icon> Limited to one supply per account.</div>
            </div>
          </el-col>
          <el-col :span="24" class="tw-mt-16">
            <div class="tw-text-[1.5rem] tw-text-white tw-font-bold">Terms and Conditions</div>
            <div class="feature__text tw-py-4 tw-text-[20px] tw-mt-4" v-if="productStore.getProductDetail.description" v-html="productStore.getProductDetail.description"></div>
          </el-col>
        </el-row>

      </div>
    </section>
    <!-- end products -->

    <section class="section">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="roadmap tw-mt-4 tw-rounded-md card-bg-active !tw-justify-between" style="align-items: normal !important;">
              <el-row class="w-full">
                <el-col :span="24" :md="18">
                  <div class="tw-text-[2rem] tw-font-bold">{{systemStore.getFrontModuleContent(25).title}}</div>
                  <div>{{systemStore.getFrontModuleContent(25).sub_title}}</div>
                </el-col>
                <el-col :span="24" :md="6" class="tw-content-center">
                  <button class="section__btn xs:tw-justify-self-center sm:tw-justify-self-end xs:tw-mt-5 md:tw-mt-0" type="button" @click="router.push({path:'/Dashboard'})">{{systemStore.getFrontModuleContent(25).description}}</button>
                </el-col>
              </el-row>

              <!-- design elements -->
              <span class="block-icon block-icon--purple">
							  <i class="ti ti-topology-star-ring"></i>
						  </span>
              <span class="screw screw--lines-bl"></span>
              <span class="screw screw--lines-br"></span>
              <span class="screw screw--lines-tr"></span>
            </div>
          </div>
        </div>
      </div>
    </section>


    <!--    dialog modal-->
    <el-dialog class="dialog-bg xs:!tw-w-[90vw] md:!tw-w-[800px]" v-model="dialogVisible" :show-close="false" title="Shipping address">
      <template #header="{ close, titleId, titleClass }">
        <div class="my-header">
          <h4 :id="titleId" :class="titleClass" class="xs:tw-ml-[2rem] md:tw-ml-[6rem] !tw-text-[24px] !tw-text-white tw-font-bold">Checkout</h4>
          <button class="modal__close" type="button" @click="dialogVisible = false"><i class="ti ti-square-x"></i></button>
        </div>
      </template>

      <div class="tw-py-12 tw-px-[2rem] tw-pb-5 tw-text-white xs:tw-text-[16px] md:!tw-text-[1.2rem]">
        <!--        <p class="modal__text">Unser Support-Team steht Ihnen jederzeit zur Verfügung, um Ihnen bei all Ihren Fragen zu helfen!</p>-->
<!--        <input name="name" type="text" class="form__input" placeholder="Name">-->
        <div class="tw-mt-3 tw-flex tw-justify-between tw-items-center">
          <div>Contract</div>
          <div>{{productStore.getProductDetail.name}}</div>
        </div>
        <div class="tw-mt-3 tw-flex tw-justify-between tw-items-center">
          <div>Unit Price</div>
          <div>$ {{parseFloat(productStore.getProductDetail.amount)}}</div>
        </div>
        <div class="tw-mt-3 tw-flex tw-justify-between tw-items-center">
          <div>Quantity</div>
          <div>{{productNum}}</div>
        </div>
        <div class="tw-mt-3 tw-flex tw-justify-between tw-items-center">
          <div>Total Purchase</div>
          <div>$ {{productNum * parseFloat(productStore.getProductDetail.amount)}}</div>
        </div>
        <el-button :loading="submitLoading" class="section__btn tw-justify-self-left tw-w-full tw-mt-8" native-type="button" @click="submit()"> {{submitLoading? 'Submitting ...': 'Invest Now'}}</el-button>
      </div>

      <!-- design elements -->
      <span class="screw screw--big-tl"></span>
      <span class="screw screw--big-bl"></span>
      <span class="screw screw--big-br"></span>

    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
:deep(.el-input__wrapper) {
  background-color: transparent !important;
  box-shadow: none !important;
  background: $p-bg-linear-active-color !important;
}
:deep(.el-input__inner){
  color: $p-text-color !important;
}
:deep(.el-input-number--large){
  height: 55px !important;
  width: 12rem !important;
  border: none !important;

  .el-input-number__decrease{
    background: rgb(53, 2, 96) !important;
    border-right: none !important;
    color: $p-text-color !important;
    width: 50px !important;
  }
  .el-input-number__increase{
    background: rgb(53, 2, 96) !important;
    border-left: none !important;
    color: $p-text-color !important;
    width: 50px !important;
  }
}

</style>
